import React from 'react'
import styled from 'styled-components'

import { ReactComponent as AsiaMilesSvg } from '@/assets/miles/asia-miles-logo.svg'
import Icon from '@/components/Icon'
import Spacer from '@/components/Spacer'
import { FormattedMiles } from '@/utils/Price'

const Container = styled.div`
  display: flex;
  align-items: center;
`

const Text = styled.div`
  font-family: 'Red Hat Display', 'Noto Sans', sans-serif;
  font-weight: 700;
  font-size: ${({ fontSize }) => fontSize};
  font-weight: 600;
  padding-top: 0.1em;
`

const AsiamilesValue = ({ miles, fontSize = '0.77rem', isSigned = true }) => {
  const isNegative = miles < 0

  return (
    <Container>
      {isSigned && (
        <>
          <Text>{isNegative ? '-' : '+'}</Text>
          <Spacer width="8px" />
        </>
      )}
      <Icon
        renderImage={() => <AsiaMilesSvg />}
        width={fontSize}
        height={fontSize}
      />
      <Spacer width="8px" />
      <Text fontSize={fontSize}>{FormattedMiles(Math.abs(miles))}</Text>
    </Container>
  )
}

export default AsiamilesValue
